import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  TextField,
  Checkbox,
  InlineStack,
  ColorPicker,
  Layout,
  Button,
  Collapsible,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ButtonColor = () => {
  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { updatedAt = "" } = currentUser || {};
  const { COPY, IS_HEADER_COPY, BUTTON, HEX, DEFAULT_BUTTON_COLOR, COLOR } = constant;
  const {
    color = {},
    errorMessage = {},
    handleChange = () => {},
    hex = {},
    isHeaderCopy = false,
    // learnMore = () => {},
    resetDefault = () => {},
  } = useContext(BrandingContext);

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.buttonColor.title")}
        description={cms("section.buttonColor.description")}
      >
        <Card
          title={[
            cms("section.buttonColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
          // actions={[{ content: "Learn more", onAction: () => learnMore(cms("section.buttonColor.title"), "TODO: ") }]}
        >
          <Card.Section>
            <BlockStack gap="10">{cms("section.buttonColor.subDescription")}</BlockStack>
            <br />
            <Checkbox
              label={cms("section.buttonColor.label.useSameColor")}
              checked={isHeaderCopy}
              onChange={(value) => handleChange(IS_HEADER_COPY, value, COPY)}
            />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack inlineAlign="stretch">
                  <TextField
                    label={cms("section.buttonColor.label.hexCode")}
                    value={hex.buttonHex}
                    onChange={(value) => handleChange(BUTTON, value, HEX)}
                    labelAction={
                      hex.buttonHex !== DEFAULT_BUTTON_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(BUTTON, DEFAULT_BUTTON_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.button}
                  />
                  <br />
                  <Box>
                    <Button variant="primary">{cms("section.buttonColor.label.sampleButton")}</Button>
                  </Box>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(BUTTON, value, COLOR)} color={color.button} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(ButtonColor), {
  feature: constant.STANDARD_BRANDING,
});
